export default "__VITE_ASSET__BFddDYUj__ 30w, __VITE_ASSET__BAMx_uz5__ 60w, __VITE_ASSET__BB19kFVQ__ 120w";